import React from 'react'
import { Helmet } from 'react-helmet'
import { WalletSection } from './styles'
import WalletPromo from './WalletPromo'
import WalletBenefits from './WalletBenefits'
/* import WalletDappDiscovery from './WalletDappDiscovery' */
/* import WalletApp from './WalletApp' */
import DownloadApp from 'components/DownloadApp'
import WalletCarousel from './WalletCarousel'
import useFetchCMSData from 'shared/hooks/useFetchCMSData'

export default function Wallet() {
  const walletData = useFetchCMSData('wallet-features')

  return (
    <>
      <Helmet>
        <title>Wallet | Lif3</title>
        <meta name="description" content="Wallet" />
      </Helmet>
      <WalletSection>
        <WalletPromo />
        <WalletBenefits />
        {walletData.length > 0 && <WalletCarousel data={walletData} />}
        {/* <WalletDappDiscovery /> */}
        <DownloadApp />
      </WalletSection>
    </>
  )
}
